var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34.523,
    viewBox: "1724 722.95 34 34.523",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "6d1af9f9792fccb756ee8fd6311a9b9a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1753.6 732.919a.512.512 0 0 1-.505-.601l.86-4.876-4.873-.86a.512.512 0 0 1 .177-1.005l5.378.948a.512.512 0 0 1 .416.593l-.948 5.378a.511.511 0 0 1-.504.423Z",
    fill: "#8481e2",
    fillRule: "evenodd",
    "data-name": "Path 93441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1727.453 748.259a.512.512 0 0 1-.308-.92l27.096-20.717a.513.513 0 0 1 .618.82l-27.097 20.714a.507.507 0 0 1-.31.103Z",
    fill: "#8481e2",
    fillRule: "evenodd",
    "data-name": "Path 93442"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1724 729.4a6.5 6.5 0 1 1 0 .1z",
    fill: "#ffc144",
    fillRule: "evenodd",
    "data-name": "Ellipse 1203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1732.446 729.44c-.277-.307-.75-.588-1.455-.857l-.318-.122v-1.697a5.673 5.673 0 0 1 1.477.372.137.137 0 0 0 .177-.076l.39-.976a.137.137 0 0 0-.075-.177 6.012 6.012 0 0 0-1.969-.441v-.751a.137.137 0 0 0-.136-.137h-.71a.137.137 0 0 0-.136.137v.776c-.622.08-1.128.28-1.502.592a1.638 1.638 0 0 0-.623 1.316c0 .49.147.908.436 1.243.29.335.73.61 1.333.842l.358.131v1.759a4.945 4.945 0 0 1-.929-.15 5.27 5.27 0 0 1-1.044-.365.136.136 0 0 0-.196.123v1.125c0 .053.03.102.08.124.55.25 1.253.389 2.09.414v.992c0 .075.06.136.136.136h.71a.137.137 0 0 0 .136-.136V732.6c.678-.091 1.21-.305 1.586-.638.398-.344.622-.849.61-1.376a1.66 1.66 0 0 0-.426-1.147Zm-1.107 1.229c0 .124 0 .489-.666.64v-1.337c.18.067.346.164.493.286a.53.53 0 0 1 .173.41Zm-1.648-3.868v1.287a1.471 1.471 0 0 1-.449-.287.575.575 0 0 1-.153-.413.494.494 0 0 1 .178-.389.993.993 0 0 1 .424-.198Z",
    fill: "#fff3da",
    fillRule: "evenodd",
    "data-name": "Path 93443"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1726 750h3a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2 2 2 0 0 1 2-2z",
    fill: "#ff9346",
    fillRule: "evenodd",
    "data-name": "Rectangle 23841"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1725.5 754h4a1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5h-4a1.5 1.5 0 0 1-1.5-1.5 1.5 1.5 0 0 1 1.5-1.5z",
    fill: "#ffc144",
    fillRule: "evenodd",
    "data-name": "Rectangle 23842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1738.952 749.965h4.096a1.877 1.877 0 0 1 1.877 1.877 1.877 1.877 0 0 1-1.877 1.877h-4.096a1.877 1.877 0 0 1-1.877-1.877 1.877 1.877 0 0 1 1.877-1.877z",
    fill: "#ff9346",
    fillRule: "evenodd",
    "data-name": "Rectangle 23843"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1738.952 753.719h4.096a1.877 1.877 0 0 1 1.877 1.877 1.877 1.877 0 0 1-1.877 1.877h-4.096a1.877 1.877 0 0 1-1.877-1.877 1.877 1.877 0 0 1 1.877-1.877z",
    fill: "#ffc144",
    fillRule: "evenodd",
    "data-name": "Rectangle 23844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1738.952 742.457h4.096a1.877 1.877 0 0 1 1.877 1.877 1.877 1.877 0 0 1-1.877 1.877h-4.096a1.877 1.877 0 0 1-1.877-1.877 1.877 1.877 0 0 1 1.877-1.877z",
    fill: "#ff9346",
    fillRule: "evenodd",
    "data-name": "Rectangle 23845"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1738.952 746.211h4.096a1.877 1.877 0 0 1 1.877 1.877 1.877 1.877 0 0 1-1.877 1.877h-4.096a1.877 1.877 0 0 1-1.877-1.877 1.877 1.877 0 0 1 1.877-1.877z",
    fill: "#ffc144",
    fillRule: "evenodd",
    "data-name": "Rectangle 23846"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1753 742h3a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2 2 2 0 0 1 2-2z",
    fill: "#ff9346",
    fillRule: "evenodd",
    "data-name": "Rectangle 23847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1753 746h3a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2 2 2 0 0 1 2-2z",
    fill: "#ffc144",
    fillRule: "evenodd",
    "data-name": "Rectangle 23848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1753 735h3a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2 2 2 0 0 1 2-2z",
    fill: "#ff9346",
    fillRule: "evenodd",
    "data-name": "Rectangle 23849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1752.5 739h4a1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5h-4a1.5 1.5 0 0 1-1.5-1.5 1.5 1.5 0 0 1 1.5-1.5z",
    fill: "#ffc144",
    fillRule: "evenodd",
    "data-name": "Rectangle 23850"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1753 750h3a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2 2 2 0 0 1 2-2z",
    fill: "#ff9346",
    fillRule: "evenodd",
    "data-name": "Rectangle 23851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1752.5 754h4a1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5h-4a1.5 1.5 0 0 1-1.5-1.5 1.5 1.5 0 0 1 1.5-1.5z",
    fill: "#ffc144",
    fillRule: "evenodd",
    "data-name": "Rectangle 23852"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesIcon);
export default __webpack_public_path__ + "static/media/sales_icon.a5e91ba7b427985038b21d449f8dbff5.svg";
export { ForwardRef as ReactComponent };